
import { compose, mdsWidget } from 'dojo/_base/declare';
import WidgetNavigationMap from '../../moreCore/UI/Navigation/WidgetNavigationMap';
import TempInvoiceFinder from './TempInvoiceFinder';
import TempInvoiceConfirmationFinder from './TempInvoiceConfirmationFinder';

/**
 * Home-Navigation f�r Orchesterdienste-Bereich
 */
class TI_HomeNavigation extends compose(WidgetNavigationMap<{}>) {

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setup({
            "Attendance_List": {
                navigationAreaName: "TempInvoice__Navigation_MainTitle",
                icon: "fas fa-receipt",
                label: "TempInvoiceConfirmation__FinderTitle",
                colorClass: "w3-deep-purple",
                roles: ["TEMPINVOICECONFIRMATION"],
                featurepath: null,
                targetWidget: TempInvoiceConfirmationFinder

            },
            "Attendance_CheckinAssociate": {
                navigationAreaName: "TempInvoice__Navigation_MainTitle",
                icon: "fas fa-file-invoice",
                label: "TempInvoice__FinderTitle",
                colorClass: "w3-purple",
                roles: ["TEMPINVOICEASSIGNMENT"],
                featurepath: null,
                targetWidget: TempInvoiceFinder
            }
        });
    }
}

export default mdsWidget(TI_HomeNavigation);